import { DashboardLayout } from '@/components/layout/DashboardLayout';
import RiskFactorAdmin from '@/components/compliance/RiskFactorAdmin';

export default function RiskAdmin() {
  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Risk Factor Configuration</h1>
          <p className="text-muted-foreground mt-2">
            Configure risk factor weights per jurisdiction to customize risk scoring algorithms.
          </p>
        </div>
        <RiskFactorAdmin />
      </div>
    </DashboardLayout>
  );
}
